// Graph utility for call trend analytics
// Central place for series definitions, colors and mapping

export const CALL_TREND_FIELDS = {
  total: 'Total Calls',
  inbound: 'InBound',
  manual: 'Manual',
  progressive: 'Progressive'
};

export const CALL_TYPE_OPTIONS = ['InBound', 'Manual', 'Progressive'];

export const SERIES_COLORS = {
  total: '#2F5597',
  inbound: '#1976D2',
  manual: '#E53935',
  progressive: '#F6C344'
};

export const DEFAULT_SELECTED_TYPE = 'InBound';

// exported to be consumable by chart formatters
export const CALL_TREND_SERIES = [
  { id: CALL_TREND_FIELDS.total, key: 'total', color: SERIES_COLORS.total },
  { id: CALL_TREND_FIELDS.inbound, key: 'inbound', color: SERIES_COLORS.inbound },
  { id: CALL_TREND_FIELDS.manual, key: 'manual', color: SERIES_COLORS.manual },
  { id: CALL_TREND_FIELDS.progressive, key: 'progressive', color: SERIES_COLORS.progressive },
];
